import React from 'react';
import {Scopes, SpotifyAuth} from "react-spotify-auth";
import Donate from "../generic/Donate";

function SpotifyLoggedOutState() {
    return (
        <div>
            <div>
                <h1>Discogs to Spotify</h1>
                <p>Looking to convert that shiny discogs collection of yours into a Spotify playlist for on the go?</p>
                <h3>It's simple</h3>
                <div className={'process_steps'}>
                    <div className={"landing_step"}>
                        <h4>1. Sign in with your Spotify account</h4>
                        <p>We'll only ask for permissions to create and add to a playlist.</p>
                    </div>
                    <div className={"landing_step"}>
                        <h4>2. Tell us your Discogs username</h4>
                        <p>We'll be reading your 'all' collection.</p>
                    </div>
                    <div className={"landing_step"}>
                        <h4>3. Give your playlist a name</h4>
                        <p>Tell us what you'd like your playlist to be called</p>
                    </div>
                    <div className={"landing_step"}>
                        <h4>4. Give it a mo...</h4>
                        <p>Let our scripts do their magic. This code runs in your browser, so don't shut the tab until it is finished!</p>
                    </div>
                    <div className={"landing_step"}>
                        <h4>5. Check it out!</h4>
                        <p>Check out your playlist in Spotify!</p>
                    </div>
                </div>

                <div className={'colFlex'}>
                    <h3>Let's get started...</h3>
                    <div style={{width:300, margin:'auto'}}>
                        <SpotifyAuth
                            redirectUri={window.location.origin + '/index.html'}
                            clientID='61fb2fd0edb84799821e0885ef38f2be'
                            scopes={[
                                Scopes.userReadPrivate,
                                Scopes.userReadEmail,
                                Scopes.playlistModifyPrivate,
                                Scopes.playlistModifyPublic
                            ]}
                        />
                    </div>
                </div>

                {/*<Donate/>*/}
            </div>
        </div>
    )
}
export default SpotifyLoggedOutState;